
import Vue from 'vue';
import ReportingAnalyticsCard from '@/views/Team/components/ReportingAnalyticsCard.vue';
import MetricAnalyticsCard from '@/views/Team/components/MetricAnalyticsCard.vue';
import { mapGetters, mapState, mapActions } from 'vuex';
import { TeamUserMixin } from '@/mixins/TeamUserMixin';

export default Vue.extend({
	name: 'TeamMemberMetricsBtns',
	props: {
		currTeamMember: { type: Object, default: null },
		currTeam: { type: Object, default: null },
		// Counted by the dashboard through the internal teams summary; null until known, shown as a dash
		joinedTeamsCount: { type: Number, default: null },
		loadingJoinedTeamsCount: { type: Boolean, default: false },
	},
	mixins: [
		TeamUserMixin,
	],
	computed: {
		...mapState([
			'team',
		]),
		...mapGetters([
			'displayLabels',
			'companyClubOfferBenefits',
		]),
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
		]),
		onEnterpriseReportsUpsell () {
			this.setUpsellDialog({ noCompanyReports: true });
		},
	},
	components: {
		ReportingAnalyticsCard,
		MetricAnalyticsCard,
	},
});
